import useFeatureFlagContext from '../hooks/useFeatureFlagContext';

export const FeatureFlagConfigurer = () => {
  useFeatureFlagContext();

  return undefined;
};
